export type Separated<Seperate> = Seperate | ((index: number) => Seperate);

export function separate<Item, separator>(
  items: Item[],
  separator: Separated<separator>,
): (Item | separator)[] {
  return items.reduce<(Item | separator)[]>(
    (reduced, child, index) =>
      index < items.length - 1
        ? reduced.concat(
            child,
            separator instanceof Function ? separator(index) : separator,
          )
        : reduced.concat(child),
    [],
  );
}
